




























import { Component, Prop, Vue } from 'vue-property-decorator'
import { percentage } from '@/plugins/filters-string'

@Component
export default class ReferralsBlockPhase extends Vue {
    @Prop({ required: true }) readonly title!: string
    @Prop({ required: true }) readonly count!: number
    @Prop({ required: true }) readonly countBackgroundColor!: string
    @Prop({ required: true }) readonly countColor!: string
    @Prop({ default: null }) readonly potentialOrderValue!: number
    @Prop({ default: null }) readonly expectedOrderValue!: number
    @Prop({ default: null }) readonly conversionPercentage!: number

    get countStyles(): {[key: string]: string} {
        return {
            'background-color': this.countBackgroundColor,
            'color': this.countColor,
        }
    }

    get expectedOrderValueTooltipContent(): string {
        return this.$t('referral-list.expectedOrderValue-tooltip', {
            conversionPercentage: percentage(this.conversionPercentage / 100, 2),
        }).toString()
    }
}
